import qs from "qs";
import request from "@/utils/requestSC";

// 添加进货车
export async function editAddr(params) {
  return request.get("mob/member/delivery/alterDelivery.do", { params });
}

// 变更客户收货地址列表
export async function editDelivery(params = {}) {
  return request.post("/rest/delivery/edit", params);
}

// 变更客户收货地址列表2
export async function editDelivery2(params = {}) {
  return request.post("/rest/delivery/edit", qs.stringify(params));
}

// 删除客户收货地址列表
export async function delDelivery(params = {}) {
  return request.post("/rest/delivery/delete", params);
}

// 新增卖家自提
export async function addSellerAddr(params = {}) {
  return request.post("/mj/addAddr.do", params);
}
